import { money } from "../utils/formatters";
import { useSession } from "@/context/SessionProvider";

// IDs que NO deben ver "Nuevo ajuste"
const DENY_NUEVO_AJUSTE_BY_ID = new Set([29]); // <-- Anterior hardcodeado por id usuario

export default function EmpresaMetrics({
    resumen,
    modo,
    isNocAdmin,
    onNavigateTransactions,
    onOpenBalanceModal,
}) {
    const { user } = useSession(); // { id, nombre, empresa_id, perfil_id }

    const canSeeNuevoAjuste =
        modo === "admin" &&
        isNocAdmin &&
        !DENY_NUEVO_AJUSTE_BY_ID.has(user?.id);

    return (
        <div className="grid grid-cols-6 gap-2 items-stretch shrink-0 w-[900px] max-w-[85vw]">
            {/* Cargos */}
            <div className="px-3 py-1.5 rounded border text-sm text-center select-none bg-rose-50/80 border-rose-200 text-rose-800 font-semibold">
                {money(resumen?.credit_used ?? 0)}
            </div>

            {/* Depósitos */}
            <div className="px-3 py-1.5 rounded border text-sm text-center select-none bg-blue-50/80 border-blue-200 text-blue-800 font-semibold">
                {money((resumen?.deposito_total ?? resumen?.debito_total) ?? 0)}
            </div>

            {/* Balance */}
            <div
                className={[
                    "px-3 py-1.5 rounded border text-sm text-center select-none font-semibold",
                    (resumen?.balance ?? 0) >= 0
                        ? "bg-emerald-50/80 border-emerald-200 text-emerald-800"
                        : "bg-rose-50/80 border-rose-200 text-rose-800",
                ].join(" ")}
                title="Balance"
            >
                {money(resumen?.balance ?? 0)}
            </div>

            {/* Crédito */}
            <div className="px-3 py-1.5 rounded border text-sm text-center select-none bg-slate-50/80 border-slate-200 text-slate-700 font-semibold">
                {money(resumen?.base_limit ?? 0)}
            </div>

            {/* Transacciones */}
            <button
                className="px-3 py-1.5 rounded border border-amber-200 bg-amber-50 hover:bg-amber-100 text-amber-800 text-sm font-medium w-full"
                onClick={(e) => {
                    e.stopPropagation();
                    onNavigateTransactions();
                }}
                type="button"
            >
                💬 <span className="hidden sm:inline">Transacciones</span>
            </button>

            {/* Nuevo ajuste */}
            {canSeeNuevoAjuste && (
                <button
                    className="px-3 py-1.5 rounded bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium w-full"
                    onClick={(e) => {
                        e.stopPropagation();
                        onOpenBalanceModal();
                    }}
                    type="button"
                >
                    ⚡ <span className="hidden sm:inline">Nuevo ajuste</span>
                </button>
            )}
        </div>
    );
}
